module.exports = __webpack_public_path__ + "img/lock-screen.01e7252d.jpg";